import { TextField } from "@material-ui/core";
import React, { Component } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import ModelBodyMain from "./Tables/ModelBodyMain";

class BlockDateOrSlot extends Component {
  render() {
    return (
      <React.Fragment>
        <Container fluid>
          <Row>
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation 
                leftText={"vendorReview"}
                backButtonLink="/manage-block-reservation-calendar"
                displayText="Back" />
              <div className="container-fluid seating_dashboard_top_new_header">
                <div className="d-flex justify-content-between align-items-center pt-4 pb-4">
                  <div className="f24_700_HelveticaNeue">
                    Manage/Block Reservation Calendar
                    <div style={{ fontSize: "14px", fontWeight: "normal" }}>
                      Manage your reservation according to your availability
                      schedule
                    </div>
                  </div>
                </div>
              </div>
              <div className="container-fluid">
                <ModelBodyMain add={true} />
              </div>
            </div>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default BlockDateOrSlot;
